import { render, staticRenderFns } from "./RadioRenderer.vue?vue&type=template&id=0650cb14&scoped=true&"
import script from "./RadioRenderer.vue?vue&type=script&lang=js&"
export * from "./RadioRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650cb14",
  null
  
)

export default component.exports